var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-goods-review',{ref:"goodsList",staticClass:"pt-goods-review__withData",on:{"approvalReject":_vm.approvalReject,"slotOut":_vm.slotOut}})}
var staticRenderFns = []

export { render, staticRenderFns }